import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import { Button, IconButton } from '@mui/material';
import { styled } from '@mui/system';
import { isEmpty } from 'lodash';

import './index.scss';
import '../scss/public.scss';
import Color from '@tool/color';
import {
  ChartIconInActive, ChartIconActive,
  TableIconInActive, TableIconActive,
} from '@styled/icon';
import moLeave, {
  initLeave, changeType,
} from './store';
import Chart from './chart';
import moIndex from '../../store/index';
import Empty from '@comp/empty/index';
import moUser from '@store/user';

interface IProps {}
interface IState {}

const DIconButton = styled(IconButton)(() => ({
  width: '32px',
  height: '20px',
  marginRight: '2px',
  borderRadius: '3px',
}));

const ActiveType = styled(DIconButton)(() => ({
  backgroundColor: Color.primary,
  '&:hover': { backgroundColor: Color.primary },
}));

const InActiveType = styled(DIconButton)(() => ({
  backgroundColor: Color.fff,
  '&:hover': { backgroundColor: Color.fff },
}));

// 人力指标 - 离职率 - 离职率时间趋势
const LeaveRateTimeTrend = (props: IProps, state: IState) => {
  const navi = useNavigate();
  const { isLogin } = moUser;
  const { industry, isMock } = moIndex;
  const {
    type, xData, yData, overview,
  } = moLeave;

  useEffect(() => {
    return () => {};
  }, []);

  return (
    <section className="leave-rate-time-trend_10">
      <p className="one-11">
        <strong>离职率时间趋势</strong>
        <span className="tag-02">{industry.name}</span>
      </p>

      <section className="box-11">
        <section className={[
          "box-13",
          !isMock ? '' : 'mock-100',
        ].join(' ')}>
          <Chart height={300} xData={xData} yData={yData} />
        </section>
        <section className="box-150">
          <strong>解读：</strong>
          <section className="box-151">
            {overview.map((text: any, index: number) => (
              <p key={index}>
                <span className="ico-11"><b /></span>
                <i>{text}</i>
              </p>
            ))}
          </section>
        </section>
      </section>
    </section>
  );
};

export default observer(LeaveRateTimeTrend);
